import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';

@Injectable()
export class SpinnerService {
    private spinnerMessageSource = new BehaviorSubject<string>(null);
    private showSpinnerSource = new BehaviorSubject<boolean>(null);

    spinnerMessage  = this.spinnerMessageSource.asObservable();
    showSpinner  = this.showSpinnerSource.asObservable();

    constructor(private router: Router) {
  }

  RefreshspinnerMessage(spinnerMessage: string) {
    this.spinnerMessageSource.next(spinnerMessage);
}

  RefreshshowSpinner(showspinner: boolean) {
    this.showSpinnerSource.next(showspinner);
}

  show()
  {
      this.RefreshshowSpinner(true);
  }

  hide()
  {
    this.RefreshshowSpinner(false);
    
  }

}